
<v-autocomplete
    v-if           = "items"
    :items         = "items"
    item-value     = "id"
    :item-text     = "itemText"
    :label         = "label"
    v-model        = "seletced"
    :return-object = true
    :rules         = "rules"
    :clearable     = "clearable"
    :readonly      = "readonly"
    @change        = "onChange"
    :hide-details  = "hideDetails"
/>
